'use client';

import Image from 'next/image';
import { LocaleLink } from '@/components/locale-link';

export function ShellLogo({
  rail = false,
  onNavigate,
}: {
  rail?: boolean;
  onNavigate?: () => void;
}) {
  return (
    <LocaleLink
      href="/overview"
      onClick={onNavigate}
      aria-label="Firmendata"
      className="flex min-h-10 shrink-0 items-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Image
        src="/images/logo.svg"
        width={40}
        height={40}
        alt=""
        priority
        unoptimized
        className="size-10 object-contain"
      />
      {!rail && (
        <span className="inline-flex items-baseline text-[22px] leading-none tracking-[-0.025em]">
          <span className="font-bold">Firmen</span>
          <span className="font-normal">data</span>
        </span>
      )}
    </LocaleLink>
  );
}
